import { render, staticRenderFns } from "./procedimientos.vue?vue&type=template&id=205d031e&scoped=true&"
import script from "./procedimientos.vue?vue&type=script&lang=js&"
export * from "./procedimientos.vue?vue&type=script&lang=js&"
import style0 from "./procedimientos.vue?vue&type=style&index=0&id=205d031e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205d031e",
  null
  
)

export default component.exports